import React, { useState, useEffect, useRef } from 'react';
import NoteInstructionsModal from "../../user/NoteInstructionsModal";
import { createPortal } from 'react-dom';
import { htmlNoteToText, splitApEntry } from '../../utils/apnote';
import { useNavigate, useParams } from 'react-router-dom';

import arrowleft from '../asserts/arrowleft.png';
import redmic from '../asserts/redmic.png';
import copydark from '../asserts/copy.svg';
import printdark from '../asserts/printicon.svg';
import Copyall from '../asserts/bi_copy.svg';
import { Backdrop, CircularProgress, Snackbar } from '@mui/material';
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faSave,faUpRightFromSquare  } from '@fortawesome/free-solid-svg-icons';
import ToastModal from '../modals/toastmodal';
import "react-quill/dist/quill.snow.css";
import MenuIcon from '@mui/icons-material/Menu';
import GridViewIcon from '@mui/icons-material/GridView';
import DangerousIcon from '@mui/icons-material/Dangerous';
import ToastMessage from '../modals/simplealert';

import { Expand } from '@mui/icons-material';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import SplitscreenOutlinedIcon from '@mui/icons-material/SplitscreenOutlined';
import DashboardIcon from '@mui/icons-material/Dashboard';
import MicIcon from '@mui/icons-material/Mic';
import IndividualRecording from './indrecording';

import CloseIcon from '@mui/icons-material/Close';
import ShareModal from '../modals/share';
import ArcheiveStreaming from './archeivestreaming';
import RecordRTC, { StereoAudioRecorder } from 'recordrtc';
import ExitModal from '../modals/exitmodal';
import DeleteConfirmation from '../modals/deleteconfirmation';
import ReactQuill from 'react-quill';
import { formatToText } from '../../utils/jsonhandlers/jsontohtml';
import { noteTextToHtml, APDiagnosisList } from '../../utils/noteFormat';
import blinkscribeapi from '../../api/blinkscribeapi';
import useStore from '../../store/zustandstore';
import ArchiveRecordingScreen from './archiveRecording';
import { crossicon } from '../../utils/svgs/svgcode';
import { useSelector } from 'react-redux';
import { isNpAttestationUser, applyAttestationToPlan, ATTESTATION_LINE } from '../../utils/npAttestation';
import { bsWsBase } from "../../api/bases";
import { appointmentMismatch, visitDateLabel } from "../../utils/recordingCompletion";
import { guardRecordingVisit } from "../../components/VisitConsent/recordingVisitGuard";
import { isVisitRefusal, isPracticeScopeRefusal, PRACTICE_SCOPE_MESSAGE } from "../../utils/visitGuard";
import { signOffNote } from "../../components/VisitConsent/signOffGuard";
import { savedLocallyNotice } from "../../notereview/noteVisit";
import { holdNavigation } from "../../utils/deferredNavigation";
import useNavigationHold from "../../utils/useNavigationHold";
import { fetchSignedNotePdf, openPrintWindow, closePrintWindow, openForPrint, downloadPdf, noteFileName, pdfErrorMessage, PDF_POPUP_BLOCKED_MESSAGE } from "./noteDocument";
// import useAudioRecorder from 'streaming/audiorecorderhook';
// import { saveAudioInIndexDB } from 'offlinestreaming/offlineBlobHandler';
// embedded: render inline in the host's own scroll area (visit modal's
// BlinkScribe tab) instead of portaling a fullscreen overlay to <body>.
// chartAppointmentId: set only when opened from a patient chart (the visit
// the chart is open for). Note-list flows don't pass it and are unchanged.
const Editscreen = ({selectedRecord,setIsEditScreen,onDone,embedded,chartAppointmentId}) => {
  const excludedKeys = ["Date", "Patient_ID", "Patient_Name", "Visit_Summary", "Appointment_Summary"];
  const INTERNAL_KEYS = new Set([
    "careiq_alerts", "current_medications", "level_of_visit",
    "level_of_visit_reasoning", "suggested_icd10", "suggested_orders", "vitals",
    "visit_class", "wellness_sequence", "applied_instructions",
    // known-name corrections audit (bsfix-name-vocab): Note Review chip, never a section
    "name_corrections",
    // order suggestions v2 payload (CareIQ order zone only; BlinkScribe never sends it here)
    "order_suggestions_v2",
  ]);
  const[jsonData,setJsonData]=useState([])
  const [instrModal, setInstrModal] = useState(null); // name of instruction to open, or null
  const [isRecording, setIsRecording] = useState(false);
  const [indisRecording,setIndIsRecording]=useState(false)
  const[isdeletedaudio,setIsdelted]=useState(false)
  const [selectedCard,setSelectedCard]=useState('')
  const [sectiondata,setSectionData]=useState({})
  const percentage = 100;
  const circleStyle = {
    background: `conic-gradient(#50869A ${percentage * 3.6}deg, #EDEDED ${percentage * 3.6}deg)`,
  };
    const [summaryjson,setSummaryJson]=useState([])
    const[userr,setUser]=useState({})
  const[popup,setPopUp]=useState(false)
  const streamname=useRef()
  const [isbuttonloading,setIsButtonLoading]=useState(false)
  const [isSaving,setIsSaving]=useState(false)
  const [indisDeletedAudio,setIndIsDeletedAudio]=useState(false)
  const [open, setOpen] = useState(false);
  const [alertmessage, setAlertMessage] = useState('');
   const [view,setView]=useState(2)
  const [severity, setSeverity] = useState('success');
  const[isLoading,setIsLoading]=useState(false)
  const mydata = useStore();
  const[config,setConfig]=useState({})
  const [configuser,setConfiguser]=useState()
  const[audiofile,setAudiofile]=useState()
  const [isSharemodal,setIsShareModal]=useState(false)
  const[toast,setToast]=useState(false)
  const [isExpanded,setIsexpanded]=useState(false)
  const [expandedRows, setExpandedRows] = useState({}); 
  const [rowSizes, setRowSizes] = useState({}); 
  const [data, setData] = useState({});
  // Download / Print of a signed note's PDF (owner request 2026-10-02):
  // '' | 'download' | 'print' while the PDF is being fetched. One request at a
  // time; both buttons disable while it runs.
  const [noteDocBusy, setNoteDocBusy] = useState('');
  // NP attestation: checkbox shown only to NPs at practice 9928. Bound to
  // np_attestation in note_json. Toggling injects/removes ATTESTATION_LINE
  // in assessment_plan so the saved note carries the attestation text.
  const userConfig = useSelector((state) => state?.userconfig);
  // Pass the whole user object: this instance derives mid-level status from
  // role rather than care's practice-9928 username allowlist.
  const showNpAttestation = isNpAttestationUser(userConfig);
  const [npAttested, setNpAttested] = useState(false);
  // Different-visit guard (stale-note fix 2026-09-28): after a recording the
  // chart opened the PREVIOUS visit's note, and saves/voice edits/sign-off
  // here re-posted it to that OLD Athena encounter. When the chart's visit
  // and the note's visit differ, show a banner and require one explicit
  // confirmation before anything is written.
  const [otherVisitConfirmed, setOtherVisitConfirmed] = useState(false);
  useEffect(() => { setOtherVisitConfirmed(false); }, [selectedRecord?.id]);
  const noteAppointmentId = data?.config?.appointmentid ?? config?.appointmentid;
  const isOtherVisitNote = appointmentMismatch(chartAppointmentId, noteAppointmentId);
  const otherVisitDate = visitDateLabel(userr?.startdate, data?.ts);
  const confirmOtherVisitWrite = (what) => {
    if (!isOtherVisitNote || otherVisitConfirmed) return true;
    const ok = window.confirm(
      `This is the note from ${otherVisitDate || 'an earlier date'} — a DIFFERENT visit than the one open in the chart.\n\n` +
      `${what} will change that earlier visit's note and re-post it to that visit's Athena encounter.\n\n` +
      `Press OK only if you mean to change the earlier visit's note. ` +
      `Press Cancel to leave it untouched (close this window to get back to today's visit).`
    );
    if (ok) setOtherVisitConfirmed(true);
    return ok;
  };
  // Visit gate for every microphone in this editor (Edit with Voice, the
  // section mics, voice edits), before any audio is captured: the note's own
  // visit (its appointment, userr from /v1/appointments/get) passes at once
  // when it is today's; any other visit is blocked when the patient has a
  // visit today and otherwise needs the two-step consent (owner rule
  // 2026-09-29). pastVisitConfirmedRef goes to BlinkScribe with the audio.
  const pastVisitConfirmedRef = useRef(false);
  const guardNoteRecording = async () => {
    const noteVisitRow = {
      appointmentid: config?.appointmentid ?? data?.config?.appointmentid,
      patientid: config?.patientid ?? data?.config?.patientid ?? userr?.patientid,
      startdate: userr?.startdate,
      starttime: userr?.starttime,
      linked_provider: userr?.linked_provider,
      providername: userr?.providername,
      visit_confirmation: userr?.visit_confirmation,
    };
    const gate = await guardRecordingVisit(noteVisitRow, { subject: "note" });
    pastVisitConfirmedRef.current = Boolean(gate.pastVisitConfirmed);
    return gate.allowed;
  };
  const [recordingField,setRecordingField]=useState('')
  const [isIndRecord,setIsIndRecord]=useState(false)
  const [isVoiceEdit, setIsVoiceEdit] = useState(false)
  const [isVoiceRecording, setIsVoiceRecording] = useState(false)
  // Every microphone here records outside RecordingContext: while one runs, a
  // location switch or an expired sign-in must not reload the page and end it
  // (utils/deferredNavigation). Audio still in flight (transcribing,
  // uploading) takes its own holdNavigation() below.
  useNavigationHold(isRecording || isIndRecord || isVoiceRecording)
  // "Report an issue" flow: log every complaint; optionally generate a fix
  // preview (existing post-processing) that the provider confirms before it
  // is applied (2026-09-12).
  const [issueModal, setIssueModal] = useState(false)
  const [issueText, setIssueText] = useState('')
  const [issuePhase, setIssuePhase] = useState('input') // input | generating | preview
  const [issuePreview, setIssuePreview] = useState(null)
  const [issueFeedbackId, setIssueFeedbackId] = useState(null)
  const [issueBusy, setIssueBusy] = useState(false)
  // Voice Edit reuses the issue preview (Apply/Reject) instead of auto-saving
  // the full LLM rewrite ('issue' | 'voice'; triage 2026-09-27, pt 7114).
  const [issueSource, setIssueSource] = useState('issue')
  const voiceRecorderRef = useRef(null)
  const voiceChunksRef = useRef([])
 const indref=useRef(null)
  const recordingfieldref=useRef('')
  const [fields, setFields] = useState({
    chiefcomplaint: '',
    hpi: '',
    ros: '',
    physicalexam: '',
    assessment: '',
    plan: ''
  });
  
  const [toastobject,setToastObject]=useState({
    icon:DangerousIcon,
    text1:"Something Went Wrong",
    text2:""

  })
  // Working copy of A&P entries once the provider removes a diagnosis via the
  // card UI; null = untouched (render straight from the loaded note). Removal
  // stages into `fields` so the existing dirty-check + Save flow persists it.
  const [mergePending, setMergePending] = useState(false);
  const [apWorkingEntries, setApWorkingEntries] = useState(null);
  useEffect(() => { setApWorkingEntries(null); }, [selectedRecord?.id]);
  const apEntries = apWorkingEntries ?? (
    Array.isArray(data?.note_json?.assessment_plan)
      ? data.note_json.assessment_plan
      : String(fields.assessment_plan || '').split('\n').map(s => s.trim()).filter(Boolean)
  );
  const handleRemoveDx = (idx) => {
    const next = apEntries.filter((_, i) => i !== idx);
    setApWorkingEntries(next);
    setFields(prev => ({ ...prev, assessment_plan: stringifyNoteValue(next) }));
  };
  const navigate = useNavigate();

const[copyFeedback,setCopyFeedback]=useState('')
  const [streamfilename,setStreamfilename]=useState('')
   const [deleteconfirmationModal,setDeleteConfirmationModal]=useState(false)
  const [isExitModal,setIsexitModal]=useState(false)
   const [elapsedTime, setElapsedTime] = useState(0);
     const [isPaused, setIsPaused] = useState(false);
     const recorderRef = useRef(null);
     const token =localStorage.getItem("auth");
     const audioStreamRef = useRef(null);
     const startTimeRef = useRef(null); // Tracks the timer's start/resume time
    const timerRef = useRef(null);
    const pausedref=useRef(false)
       const ismanualstop=useRef(false)
    const ismanualrecordstart=useRef(false)
    const wsRef = useRef(null)
      const blocker=useRef(false)
    const formatTime = (seconds) => {
      const minutes = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
    }
const handleClose = (event, reason) => {
  if (reason === 'clickaway') {
    return;
  }
  setOpen(false);
}; 
const onSaving = (blob) => {
  if (blob && blob.type.startsWith("audio/")) {   
    console.log("Valid audio blob:", blob);
    // Call the function to submit the audio blob
    if(blocker.current){
      return
    }
    submitAudioBlobManually(blob);
  } else {
    console.error("Invalid blob. Not an audio file.");
  }

};

// const {  manualrecord, stopmanualRecording, pausemanualRecording , resumemanualRecording } = useAudioRecorder(onSaving);
 // Coerce note_json / summary_json values to strings so the render's .replace() /
 // .substring() chains never hit a non-string. Arrays render as newline-joined
 // bullets so A/P stays editable; numbers/objects become their string form.
 // Some pipelines (the migrated 1111/Dallas instance, some LLM templates)
 // store note fields as HTML; the editor renders plain text, so convert
 // markup to readable text with paragraph breaks (QA 2026-08-19, pt 13795).
 // htmlNoteToText / splitApEntry now come from the shared util (utils/apnote)
 // so all four note surfaces normalize identically — including literal \n
 // escape sequences some pipelines emit (rec 18281).
 // Some LLM outputs pack the ENTIRE assessment/plan into one entry with every
 // diagnosis as an embedded "Title (ICD):" heading — that renders as a single
 // giant card. Split such blobs into one entry per diagnosis heading so each
 // ICD-10 gets its own sub-card (QA 2026-08-20, rec 18272). Entries with a
 // single heading (the normal shape) are returned unchanged.
 const stringifyNoteValue = (v) => {
   if (v == null) return '';
   if (typeof v === 'string') return htmlNoteToText(v);
   if (Array.isArray(v)) return v.map(x => (typeof x === 'string' ? htmlNoteToText(x) : JSON.stringify(x))).join('\n');
   if (typeof v === 'object') return JSON.stringify(v, null, 2);
   return String(v);
 };
 // On save, turn the edited string back into the same shape as the original value.
 const restoreNoteType = (stringVal, originalVal) => {
   if (Array.isArray(originalVal)) {
     return (stringVal || '').split('\n').map(s => s.trim()).filter(Boolean);
   }
   if (typeof originalVal === 'number') {
     const n = Number(stringVal);
     return Number.isFinite(n) ? n : stringVal;
   }
   if (originalVal && typeof originalVal === 'object' && !Array.isArray(originalVal)) {
     try { return JSON.parse(stringVal); } catch { return stringVal; }
   }
   return stringVal;
 };
 const stringifyNoteJson = (nj) => {
   const out = {};
   for (const k of Object.keys(nj || {})) out[k] = stringifyNoteValue(nj[k]);
   return out;
 };
 const handlealertClick = (message,severity) => {
  setAlertMessage(message);
  setSeverity(severity);
  setOpen(true);
};
  // Signed note → PDF from BlinkScribe (GET /v1/documents/pdf/{audiolink}).
  // 'download' saves Note_<visit date>_<recording id>.pdf; 'print' opens the
  // PDF in a new tab where the browser's viewer offers Print. Errors become a
  // toast (404 = not generated yet / other host); nothing throws into render.
  const noteDocReady = Boolean(data?.audiolink) && !noteDocBusy;
  const handleNoteDocument = async (mode) => {
    if (noteDocBusy || !data?.audiolink) return;
    // Print: the tab is opened HERE, synchronously inside the click, and only
    // navigated to the PDF once it has arrived. A window.open after the await
    // is blocked by Safari (iPad) and by Chrome after ~5 s of activation.
    const printWin = mode === 'print' ? openPrintWindow() : null;
    if (mode === 'print' && !printWin) {
      handlealertClick(PDF_POPUP_BLOCKED_MESSAGE, 'warning');
      return;
    }
    setNoteDocBusy(mode);
    try {
      const blob = await fetchSignedNotePdf(data.audiolink);
      if (mode === 'download') {
        downloadPdf(blob, noteFileName({ startdate: userr?.startdate, ts: data?.ts, id: data?.id ?? selectedRecord?.id }));
      } else if (!openForPrint(blob, { win: printWin })) {
        handlealertClick(PDF_POPUP_BLOCKED_MESSAGE, 'warning');
      }
    } catch (err) {
      closePrintWindow(printWin);
      console.error('Note PDF fetch failed', err);
      handlealertClick(pdfErrorMessage(err), 'error');
    } finally {
      setNoteDocBusy('');
    }
  };
  const noteDocLabel = (mode) => {
    if (noteDocBusy === mode) return mode === 'download' ? 'Downloading...' : 'Opening...';
    return mode === 'download' ? 'Download' : 'Print';
  };
  const noteDocTitle = (mode) => {
    if (!data?.audiolink) return 'No document is on file for this note';
    return mode === 'download' ? 'Download the signed note as a PDF' : 'Open the signed note PDF in a new tab to print it';
  };
  const fetchData = async () => {
    setIsLoading(true)
    setFields({
      chiefcomplaint: '',
      hpi: '',
      ros: '',
      physicalexam: '',
      assessment: '',
      plan: ''
    })
    try {
      const response = await blinkscribeapi.get(`/v1/recording/note/${selectedRecord?.id}/get`);
      if (response.status === 200) {
               const initialData =response.data[0]
        // Normalize foreign-template HTML (migrated 1111/Dallas notes) ONCE at
        // ingestion, so every consumer — the A&P entry parser (which reads
        // note_json directly, bypassing stringifyNoteValue), the field editors,
        // and save payloads — sees plain text. No-op for native notes.
        if (initialData?.note_json && typeof initialData.note_json === 'object') {
          const nj = initialData.note_json;
          for (const k of Object.keys(nj)) {
            const v = nj[k];
            if (typeof v === 'string') nj[k] = htmlNoteToText(v);
            else if (Array.isArray(v)) {
              let arr = v.map(x => (typeof x === 'string' ? htmlNoteToText(x) : x));
              if (k === 'assessment_plan') {
                arr = arr.flatMap(x => (typeof x === 'string' ? splitApEntry(x) : [x]));
              }
              nj[k] = arr;
            }
          }
        }
        setData(initialData);
        // Merge-in-progress indicator: a NEWER recording on this appointment
        // still Processing/Submitted means this note is about to be superseded
        // by a merge - warn instead of letting a stale note read as final
        // (QA 2026-08-18: 73-min merge window read as "diagnoses missing").
        try {
          const apptId = initialData?.config?.appointmentid;
          const ptId = initialData?.config?.patientid;
          if (apptId && ptId) {
            const today = new Date().toISOString().slice(0, 10);
            const lst = await blinkscribeapi.post(`/v1/patient/${ptId}/recording/details`,
              { filter_array: { date_filter: { start_date: today, end_date: today } }, limit: 30 });
            const rows = lst?.data || [];
            setMergePending(Array.isArray(rows) && rows.some(r =>
              r && r.id !== initialData.id &&
              String(r.config_appointmentid || '') === String(apptId) &&
              (r.transcriptionstatus === 'Processing' || r.transcriptionstatus === 'Submitted')));
          } else { setMergePending(false); }
        } catch (_) { setMergePending(false); }
        const notesArray = Object.keys(initialData?.note_json||{})
        .filter(key => !excludedKeys.includes(key) && !INTERNAL_KEYS.has(key))
        .map((key, index) => ({
            id: index + 1,
            label: key.replace(/_/g, " "),
            key: key,
            title: key,
            value: stringifyNoteValue(initialData.note_json[key]),
            placeholder: key,
        }));
        const order = [
          "chief_complaint",
          "physical_examination",
          "review_of_systems",
          "hpi",
          "assessment_plan",
          "doctor_instructions",
          "patient_directions",
          "allergies",
          "medical_history",
          "surgical_history",
          "family_history",
          "social_history",
      ];
      
      
      const sortedData = Array.isArray(notesArray)
          ? order.map(key => notesArray.find(item => item.key === key)).filter(Boolean)
          : [];


          const transformKeysToLowercase = (obj) => {
            if (!obj || typeof obj !== 'object') return obj;
          
            return Object.keys(obj).reduce((acc, key) => {
              acc[key.toLowerCase()] = obj[key];
              return acc;
            }, {});
          };
          
          setSummaryJson(stringifyNoteJson(transformKeysToLowercase(initialData?.summary_json || {})));

          // setSummaryJson(initialData?.summary_json||{})
setJsonData(sortedData||[])
setConfiguser(response.data[0])
        setConfig(response.data[0].config)
        setFields(stringifyNoteJson(initialData?.note_json))
        // Restore NP attestation state from the saved note_json
        setNpAttested(Boolean(initialData?.note_json?.np_attestation))
        const user= await blinkscribeapi.get(`/v1/appointments/get/${response.data[0].config?.appointmentid}`)
        if(user.status===200){
          setUser(user?.data)
        } 
         }
    } catch (error) {
      console.error('Error fetching data', error);
    }finally{
      setIsLoading(false)
    }
    
  };
 

  useEffect(() => {
    fetchData();

    console.log(selectedRecord,'sele')
  }, [selectedRecord?.id]);
  const submitdata = async (payload, text,fieldname) => {
    if (!confirmOtherVisitWrite('Saving')) return;
    const a = fieldname;
    const b = text;
    const obj = { [a]: b };
    const transformedData = {
      "context_dict": obj 
    };
    setIsLoading(true); 
   
    try {
      const response = await blinkscribeapi.put('/v1/recording/category/update',{
            ...transformedData,
        file_name:data.audiolink
      
      });
      // A note filed to another day's visit is saved in BlinkScribe only.
      const localOnly = savedLocallyNotice(response);
      if (localOnly) handlealertClick(localOnly, 'warning');
      fetchData()
      // Handle response here if needed
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
   
  };
   const submitAudioBlobManually=async(blob)=>{
      
      if(isdeletedaudio){
        setAudiofile('')
        handlealertClick('Recording has been Deleted','error')
      }else{
    
        try {
  let modifiedcategory='combine'
  console.log(isIndRecord,'isind')

  if(indref.current){
     modifiedcategory=recordingfieldref.current
    }
  
  
         
        console.log("inserting into index db ...")
//     saveAudioInIndexDB({
//       file:blob, practiceid:config.practiceid, departmentid:config.departmentid
//       , patientid:config.patientid, notes:'testing data', tags:'tagsdata', 
//       patientname:name, templatename:config?.template_name||null, role:mydata.usertype, 
//        filename: streamname.current,appointmentid:"",category:modifiedcategory,
//        appointmentid:config?.appointmentid||null,rowid:id,status:"edit",streamingfilename:data.audiolink,userid:configuser?.user_id
//    })
          
        } catch (error) {
          console.error('Error uploading audio:', error);
        }finally{
      
          setIsexitModal(false)
        }
        
        }
      
    
    }
  
  const handleSignoff=async()=>{
    if(isbuttonloading)return
    if (!confirmOtherVisitWrite('Signing off')) return;
    setIsButtonLoading(true)
    try {
      // Sign Off can be clicked before the note fetch completes (the editor
      // auto-opens on processing-finish); an undefined audiolink became a 422
      // and surfaced as "Something went wrong" (QA 2026-08-18).
      if (!data?.audiolink) {
        handlealertClick('Note is still loading - please try again in a moment', 'info');
        return;
      }
      // A note filed to another day's visit: BlinkScribe answers 409
      // VISIT_MISMATCH and signOffNote asks twice before signing it there.
      const response= await signOffNote({"document_name":data?.audiolink}, { visit: { patientid: data?.config?.patientid ?? config?.patientid, appointmentid: data?.config?.appointmentid ?? config?.appointmentid } })
      if(response?.cancelled){
       handlealertClick('Not signed', 'info');
      }else if(response?.inProgress){
       // Another Sign Off of this note is still running (this tab, another
       // tab or device): nothing was sent again. Not an error.
       handlealertClick(response.message, 'info');
      }else if(response.status===200){
       handlealertClick('Signed!');
        
        // setSeverity('success'); // Change severity as needed
       
        setOpen(true);
        setTimeout(() => {
          if (onDone) { onDone(); }
          else { navigate('/landing', { replace: true }); }
        }, 1000);
      }else if(response.status===201){
       // setMessage(response.message);
        // setSeverity('info'); // Change severity as needed
        handlealertClick(response.message)
        setOpen(true);    
      }
    } catch (error) {
      // Sign-off failures return 422 with a specific reason (e.g. the visit
      // has no Athena encounter) — show it instead of the generic message.
      const serverMsg = error?.response?.data?.message;
      handlealertClick(serverMsg || 'something went wrong','error')
      setOpen(true);
    }finally{
      setIsButtonLoading(false)
      fetchData()
    }

  }
  const copyToClipboard = (htmlText) => {
    // Create a temporary div to parse HTML
    const tempElement = document.createElement("div");
    tempElement.innerHTML = htmlText;
    tempElement.querySelectorAll("br")?.forEach(br => br.replaceWith("\n"));
    // Extract plain text without HTML tags
    const plainText = tempElement.innerText || tempElement.textContent;

    // Copy to clipboard
    navigator.clipboard.writeText(plainText)
      .then(() => {
        handlealertClick("Copied to clipboard!", "success");
      })
      .catch(err => {
        console.error("Failed to copy text: ", err);
      });
  };


  const handleFieldChange = (fieldName, value) => {
    setFields(prevFields => ({ ...prevFields, [fieldName]: value }));
  };

  const getChangedNoteFields = () => {
    const changedFields = {};
    const originalNoteJson = data?.note_json || {};
    for (const key in fields) {
      const originalStr = stringifyNoteValue(originalNoteJson[key]);
      if (fields[key] !== originalStr) {
        changedFields[key] = restoreNoteType(fields[key], originalNoteJson[key]);
      }
    }
    if (showNpAttestation && Boolean(originalNoteJson.np_attestation) !== npAttested) {
      changedFields.np_attestation = npAttested;
    }
    // Card-based diagnosis removal: apWorkingEntries IS the authoritative
    // post-removal array. The string roundtrip (join '\n' then split '\n')
    // fragments multi-line entries - removing 1 of 4 diagnoses exploded the
    // other 3 into one-line shards (QA 2026-08-18 #4).
    if (apWorkingEntries) {
      changedFields.assessment_plan = apWorkingEntries;
    }
    return changedFields;
  };

  const saveChangedNoteFields = async () => {
    const changedFields = getChangedNoteFields();
    if (Object.keys(changedFields).length === 0) return null;
    const saveRes = await blinkscribeapi.put('/v1/recording/category/update', {
      context_dict: changedFields,
      file_name: data.audiolink,
    });
    const localOnly = savedLocallyNotice(saveRes);
    if (localOnly) handlealertClick(localOnly, 'warning');
    setData(prev => ({
      ...prev,
      ...changedFields,
      note_json: { ...(prev?.note_json || {}), ...changedFields },
    }));
    return changedFields;
  };

  const handleSaveIconClick = async (fieldName) => {
    if (isSaving) return;
    if (!confirmOtherVisitWrite('Saving')) return;
    const originalVal = (data?.note_json || {})[fieldName];
    const restoredVal = restoreNoteType(fields[fieldName], originalVal);
    setIsSaving(true);
    try {
      const saveRes = await blinkscribeapi.put('/v1/recording/category/update', {
        context_dict: { [fieldName]: restoredVal },
        file_name: data.audiolink,
      });
      setData(prev => ({
        ...prev,
        [fieldName]: restoredVal,
        note_json: { ...(prev?.note_json || {}), [fieldName]: restoredVal },
      }));
      setPopUp(false);
      const localOnly = savedLocallyNotice(saveRes);
      handlealertClick(localOnly || 'Saved', localOnly ? 'warning' : 'success');
    } catch (err) {
      console.error('Save failed:', err);
      handlealertClick('Save failed — please retry', 'error');
    } finally {
      setIsSaving(false);
    }
  };


  // Toggle NP attestation. Updates the in-memory assessment_plan immediately
  // (so the editor reflects the change before save) and the boolean flag.
  const handleNpAttestationToggle = (checked) => {
    setNpAttested(checked);
    const originalNoteJson = data?.note_json || {};
    const originalPlan = originalNoteJson.assessment_plan;
    const updatedPlan = applyAttestationToPlan(originalPlan, checked);
    setFields(prev => ({ ...prev, assessment_plan: stringifyNoteValue(updatedPlan) }));
  };

  const handleSaveButtonClick = async() => {
    if (isSaving) return;
    if (data.transcriptionstatus === 'Processing') {
      setAlertMessage('Update in process. Hold on!');
      setSeverity('info');
      setOpen(true);
      return;
    }

    const changedFields = getChangedNoteFields();
    if (Object.keys(changedFields).length === 0) {
      handlealertClick('No changes to save', 'info');
      return;
    }
    if (!confirmOtherVisitWrite('Saving')) return;

    setIsSaving(true);
    try {
      await saveChangedNoteFields();
      handlealertClick('Saved', 'success');
      setPopUp(false);
    } catch (err) {
      console.error('Save failed:', err);
      handlealertClick('Save failed — please retry', 'error');
    } finally {
      setIsSaving(false);
    }
  };
  const submitIndAudio= async (blob)=>{
    if (!indisDeletedAudio && !confirmOtherVisitWrite('Adding this recording')) return;
    if(indisDeletedAudio){
      setAudiofile('')
      handlealertClick('Recording has been Deleted','error')
      setIsIndRecord(false)
      setRecordingField('')
      setIndIsDeletedAudio(false)
      indref.current=false
    }else{
 // The recording exists only here until uploaded (utils/deferredNavigation).
 const releaseHold = holdNavigation()
 setIsIndRecord(false)


try {
  await saveChangedNoteFields();
  const ts1 = new Date().toISOString().replace(/[-:.TZ]/g, '').slice(0, 14);
  const gfn1 = `${config.practiceid}_${config.departmentid}_${config.patientid}_${config.appointmentid}_${ts1}.txt`;
  const formData = new FormData();
  formData.append("file", blob);
  formData.append("generated_file_name", gfn1);
  formData.append("departmentid", config.departmentid);
  formData.append("category", recordingField);
  formData.append("patientname", selectedRecord?.patient_name);
  formData.append("patientid", config.patientid);
  formData.append("appointmentid", config.appointmentid);
  formData.append("notes", "testing data");
  formData.append("practiceid", config.practiceid);
  formData.append("filename", data.audiolink);
  formData.append("rowid", selectedRecord?.id);
  formData.append("tags", 'tagsdata');
  formData.append("client", "care");
  if (pastVisitConfirmedRef.current) formData.append("past_visit_confirmed", "true");


  const response = await blinkscribeapi.post('v1/ehr/recording/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  if (response.status == 200) {
    handlealertClick('Recording Has Been Uploaded');
    navigate(-1)

  } else {
    handlealertClick('Something Went Wrong', 'error');
  }
  
} catch (error) {
  console.error('Error uploading audio:', error);
  // BlinkScribe's visit guard (409 today's visit exists / 428 needs consent).
  const st = error?.response?.status;
  if (st === 409 || st === 428) {
    const m = error?.response?.data?.message;
    handlealertClick((typeof m === 'string' && m) || 'BlinkScribe refused this recording for its visit', 'error');
  }
}finally{
  setRecordingField('')
  releaseHold()
}
    }
  }
const submitAudio= async (blob)=>{
  if (!isdeletedaudio && !confirmOtherVisitWrite('Adding this recording')) return;
  if(isdeletedaudio){
    setAudiofile('')
    handlealertClick('Recording has been Deleted','error')
  }else{
    // The recording exists only here until uploaded (utils/deferredNavigation).
    const releaseHold = holdNavigation();
    try {
      await saveChangedNoteFields();
      const ts2 = new Date().toISOString().replace(/[-:.TZ]/g, '').slice(0, 14);
      const gfn2 = `${config.practiceid}_${config.departmentid}_${config.patientid}_${config.appointmentid}_${ts2}.txt`;
      const formData = new FormData();
      formData.append("file", blob);
      formData.append("generated_file_name", gfn2);
      formData.append("departmentid", config.departmentid);
      formData.append("category", "combine");
      formData.append("patientname",selectedRecord?.patient_name);
      formData.append("patientid", config.patientid);
      formData.append("appointmentid", config.appointmentid);
      formData.append("notes", "testing data");
      formData.append("practiceid", config.practiceid);
      formData.append("filename", data.audiolink);
      formData.append("rowid", selectedRecord?.id);
      formData.append("tags", 'tagsdata');
      formData.append("client", "care");
      if (pastVisitConfirmedRef.current) formData.append("past_visit_confirmed", "true");
      
      const response = await blinkscribeapi.post('v1/ehr/recording/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    
      if (response.status == 200) {
        handlealertClick('Recording Has Been Uploaded');
        navigate(-1)
  
      } else {
        handlealertClick('Something Went Wrong', 'error');
      }
      
    } catch (error) {
      console.error('Error uploading audio:', error);
      // BlinkScribe's visit guard (409 today's visit exists / 428 needs consent).
      const st = error?.response?.status;
      if (st === 409 || st === 428) {
        const m = error?.response?.data?.message;
        handlealertClick((typeof m === 'string' && m) || 'BlinkScribe refused this recording for its visit', 'error');
      }
    } finally {
      releaseHold();
    }
    
    }
}
const handleCopyallText = () => {
let textToCopy = '';

function formatValue(key, value, indent = '') {
  if (Array.isArray(value)) {
    // Format array values as a list
    return `${key}:\n${value.map(item => `${indent}- ${formatValue('', item, indent + '  ')}`).join('\n')}`;
  } else if (typeof value === 'object' && value !== null) {
    // Format nested object properties recursively
    let formattedObject = `${key}:\n`;
    for (const subKey in value) {
      if (value.hasOwnProperty(subKey)) {
        formattedObject += `${indent}${formatValue(subKey, value[subKey], indent + '  ')}\n`;
      }
    }
    return formattedObject.trim();
  } else {
    // Strip HTML if value is a string
    const tempElement = document.createElement("div");
    tempElement.innerHTML = value;
    tempElement.querySelectorAll("br")?.forEach(br => br.replaceWith("\n"));
    const formattedValue = tempElement.innerText || tempElement.textContent;
    return `${key}: ${formattedValue}`;
  }
}

for (const key in fields) {
  if (fields.hasOwnProperty(key) && !INTERNAL_KEYS.has(key)) {
    textToCopy += `${formatValue(key, fields[key])}\n\n`;
  }
}






  navigator.clipboard.writeText(textToCopy)
    .then(() => {
      handlealertClick('Copied to Clipboard', 'success');
    })
    .catch(err => {
      console.error('Failed to copy text: ', err);
      handlealertClick('Something went wrong', 'error');
    });
};

const handleExpandClick = (key, text) => {
  console.log("Current Expanded Rows:", expandedRows); // Debug log
  console.log("Clicked Row Key:", key);

  setExpandedRows((prev) => {
    const newExpandedRows = {};
    // Loop through previous state to update expansion
    Object.keys(prev).forEach((k) => {
      newExpandedRows[k] = k === key ? !prev[k] : false; // Toggle clicked row
    });
    console.log("New Expanded Rows:", newExpandedRows); // Debug log for new state
    return newExpandedRows; // Return updated state
  });

  // Calculate new row size
  calculateRows(key, text);
};
const calculateRows = (key, text) => {
  const lineHeight = 20; // Approximate line height in pixels
  const maxHeight = 100; // Initial height in pixels
  // Calculate the number of lines based on the text length
  const rows = Math.ceil(text.length / (maxHeight / lineHeight)); // Adjusted calculrration
  const newSize = Math.max(rows, 1); // Ensure at least one row is displayed

  setRowSizes((prev) => ({
    ...prev,
    [key]: newSize, // Set the row size for the specific section
  }));
  
  return newSize; // Return the calculated size
};

const startRecording = async (category='combine') => {
  pausedref.current = false;
  // A new session: a previous stop must not mask this socket's close.
  ismanualstop.current = false;
  try {
    const text = crypto.randomUUID();
    setStreamfilename(text)
    streamname.current=text
    const filename = data.audiolink;
    const practiceid = config.practiceid || "";
    const departmentid = config.departmentid || "";
    const templatename=config.template_name||null
    const appointmentid = config.appointmentid

    const tags = "Sample tags";
    const patientname =selectedRecord?.patient_name;
    const isBusinessUser = mydata.usertype=='BUSINESS';
    const patientid = config.patientid
    const notes ="testing data"
    const ts = new Date().toISOString().replace(/[-:.TZ]/g, '').slice(0, 14);
    const generatedfilename = `${practiceid}_${departmentid}_${patientid}_${appointmentid}_${ts}.txt`;
  const ws = new WebSocket(
  `${bsWsBase()}/v1/recording/streaming?token=${token}&generated_file_name=${generatedfilename}&rowid=${selectedRecord?.id}&stream_filename=${text}&practiceid=${practiceid}&departmentid=${departmentid}&patientid=${patientid}&appointmentid=${appointmentid}&notes=${encodeURIComponent(
    notes
  )}&tags=${encodeURIComponent(tags)}&filename=${filename}&category=${category}&patientname=${encodeURIComponent(patientname)}&template_name=${encodeURIComponent(templatename)}&client=care${pastVisitConfirmedRef.current ? '&past_visit_confirmed=true' : ''}`

);

    wsRef.current = ws;

    ws.onopen = () => {
    
      console.log("WebSocket connection established.");
    };

    ws.onerror = (error) => {
      ismanualrecordstart.current=true
    //   manualrecord()
      console.error("WebSocket error:", error);
    
  
    };

    ws.onclose = (event) => {
      // Refused by BlinkScribe's visit guard (4409 / 4428): stop capturing
      // and say why; nothing was added to the note.
      if (!ismanualstop.current && isVisitRefusal({ code: event?.code, reason: event?.reason })) {
        ismanualstop.current = true;
        try { recorderRef.current && recorderRef.current.stopRecording(() => { recorderRef.current = null; }); } catch (_) {}
        try { audioStreamRef.current && audioStreamRef.current.getTracks().forEach((t) => t.stop()); } catch (_) {}
        audioStreamRef.current = null;
        stopTimer();
        setIsRecording(false);
        setIsIndRecord(false);
        setRecordingField('');
        setIsVoiceEdit(false);
        handlealertClick(
          isPracticeScopeRefusal({ code: event?.code, reason: event?.reason })
            ? `${PRACTICE_SCOPE_MESSAGE} Nothing was added to the note.`
            : 'BlinkScribe refused this recording for its visit; nothing was added to the note.',
          'error'
        );
        return;
      }
      if(!ismanualstop.current){
        ismanualrecordstart.current=true
        console.log('manual record initiated')
        // manualrecord()


      }
      console.log("WebSocket connection closed.");
    };

    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    audioStreamRef.current = stream;

    const recorder = new RecordRTC(stream, {
      type: "audio",
      recorderType: StereoAudioRecorder,
      mimeType: "audio/webm",
      timeSlice:5000, // Send data every 5 seconds
      desiredSampRate: 48000,
      numberOfAudioChannels: 1,
      ondataavailable: async (blob) => {
     
        if (ws.readyState === WebSocket.OPEN && !pausedref.current) {
          try {
          
            const base64Data = await blobToBase64(blob);
            ws.send(base64Data);
          } catch (error) {
            console.error("Error converting blob to base64:", error);
          }
        }
      },
    });

    recorder.startRecording();
    recorderRef.current = recorder;

    setElapsedTime(0);
    startTimer();
  
    setIsPaused(false);
  } catch (error) {
    console.error("Error starting recording:", error);
   
  }
};
const startTimer = () => {
  startTimeRef.current = Date.now() - elapsedTime * 1000; // Adjust for any previously elapsed time
  timerRef.current = setInterval(() => {
    const timePassed = Math.floor((Date.now() - startTimeRef.current) / 1000);
    setElapsedTime(timePassed);
  }, 1000);
};

const stopTimer = () => {
  clearInterval(timerRef.current);
  timerRef.current = null;
};

const togglePause = () => {

  if (pausedref.current) {
    // Resume the timer
    pausedref.current=false
  setIsPaused(false)
    startTimer();
    if(ismanualrecordstart){
    //   resumemanualRecording()
    }
  } else {
    // Pause the timer
    if(ismanualrecordstart){
    //   pausemanualRecording()
   }
    pausedref.current=true
   setIsPaused(true)
    stopTimer();
  }

};
// ── Voice Edit: local recording → transcribe → post-processing → refresh ──
const startVoiceEdit = async () => {
  if (!confirmOtherVisitWrite('A voice edit')) return;
  if (!(await guardNoteRecording())) return;
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    voiceChunksRef.current = [];
    const recorder = new MediaRecorder(stream, { mimeType: 'audio/webm' });
    recorder.ondataavailable = (e) => { if (e.data.size > 0) voiceChunksRef.current.push(e.data); };
    recorder.start();
    voiceRecorderRef.current = recorder;
    setIsVoiceRecording(true);
    handlealertClick('Recording — speak your edits', 'info');
  } catch (err) {
    console.error('Mic access failed:', err);
    handlealertClick('Could not access microphone', 'error');
  }
};

const stopVoiceEdit = async () => {
  const recorder = voiceRecorderRef.current;
  if (!recorder) return;
  // A second click while this stop is still finishing (a double-click, or the
  // red circle and "Stop & Apply") must not take a second hold: it would
  // replace onstop, the first promise would never resolve and its hold would
  // never be released (location switches then did nothing until F5).
  if (recorder.__stopping) return;
  recorder.__stopping = true;
  // The dictation exists only in this page until it is transcribed and
  // merged: hold reloads/redirects until then (utils/deferredNavigation).
  const releaseHold = holdNavigation();
  return new Promise((resolve) => {
    recorder.onstop = async () => {
      setIsVoiceRecording(false);
      const blob = new Blob(voiceChunksRef.current, { type: 'audio/webm' });
      voiceRecorderRef.current.stream?.getTracks().forEach(t => t.stop());
      voiceRecorderRef.current = null;

      if (blob.size < 1000) {
        handlealertClick('Recording too short', 'error');
        resolve();
        return;
      }

      setIsLoading(true);
      handlealertClick('Transcribing...', 'info');

      try {
        // Step 1: Transcribe audio
        const formData = new FormData();
        formData.append('file', blob, 'voice_edit.webm');
        const transcribeResp = await blinkscribeapi.post('/v1/recording/transcribe-only', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          timeout: 60000,
        });
        const transcript = transcribeResp?.transcript || transcribeResp?.data?.transcript;
        if (!transcript) {
          handlealertClick('Could not transcribe audio', 'error');
          setIsLoading(false);
          resolve();
          return;
        }

        handlealertClick('Preparing your edits...', 'info');
        await saveChangedNoteFields();

        // Step 2: Post-processing — merge transcript into existing note.
        // The raw transcript used to go in unframed and the whole rewrite was
        // saved, wiping CC/HPI/ROS/PE/A&P content (triage 2026-09-27). Frame
        // it as additive, like the report-issue flow. No template_name: that
        // routes to a template-transform prompt that ignores the comments.
        const postResp = await blinkscribeapi.put('/v1/document/post-processing', {
          file_name: data?.audiolink,
          category: 'all',
          comments: `The provider dictated the following additions/corrections: "${transcript}". ` +
            'Add new information to the relevant sections. Do not remove, shorten or ' +
            'rewrite existing content unless the dictation explicitly says to remove or ' +
            'replace it. Keep sections the dictation does not mention verbatim.',
        }, { timeout: 120000 });

        const updatedNote = postResp?.content || postResp?.data?.content;
        if (updatedNote && typeof updatedNote === 'object') {
          // Step 3: nothing is saved yet — show the report-issue preview;
          // applyIssueFix writes only the sections the provider approves.
          setIssueSource('voice');
          setIssueFeedbackId(null);
          setIssuePreview(updatedNote);
          setIssuePhase('preview');
          setIssueModal(true);
        } else {
          handlealertClick('Edit processing failed — try again', 'error');
        }
      } catch (err) {
        console.error('Voice edit error:', err);
        handlealertClick('Voice edit failed', 'error');
      } finally {
        setIsLoading(false);
      }
      resolve();
    };
    // A recorder that is already inactive (the microphone dropped) fires no
    // stop event: run the handler directly so the dictation is still handled
    // and the hold released.
    if (recorder.state === 'inactive') recorder.onstop();
    else recorder.stop();
  }).finally(releaseHold);
};

// ── Report-an-issue flow: always log; optional confirm-before-apply fix ──
const closeIssueModal = () => {
  setIssueModal(false);
  setIssueText('');
  setIssuePhase('input');
  setIssuePreview(null);
  setIssueFeedbackId(null);
  setIssueSource('issue');
};

const issueChangedSections = () => {
  if (!issuePreview || typeof issuePreview !== 'object') return [];
  const current = data?.note_json || {};
  const out = [];
  for (const k of Object.keys(issuePreview)) {
    const before = stringifyNoteValue(current[k]);
    const after = stringifyNoteValue(issuePreview[k]);
    if ((after || '').trim() && after !== before) {
      out.push({ key: k, before, after });
    }
  }
  return out;
};

const submitIssue = async (fixNow) => {
  const textVal = issueText.trim();
  if (!textVal) return;
  if (fixNow && !confirmOtherVisitWrite('Fixing this note')) return;
  setIssueBusy(true);
  try {
    const fb = await blinkscribeapi.post('/v1/note-feedback/log', {
      recording_id: data?.id,
      issue_text: textVal,
      action: fixNow ? 'fix_attempted' : 'logged_only',
    });
    setIssueFeedbackId(fb?.id ?? fb?.data?.id ?? null);
    if (!fixNow) {
      handlealertClick('Issue logged — the team will review it', 'success');
      closeIssueModal();
      return;
    }
    setIssuePhase('generating');
    await saveChangedNoteFields();
    const postResp = await blinkscribeapi.put('/v1/document/post-processing', {
      file_name: data?.audiolink,
      category: 'all',
      comments: `The provider reports a problem with this note: "${textVal}". ` +
        'Correct the note to resolve exactly this problem. Only change what the ' +
        'problem requires; keep every other section verbatim.',
    }, { timeout: 120000 });
    const updated = postResp?.content || postResp?.data?.content;
    if (updated && typeof updated === 'object') {
      setIssuePreview(updated);
      setIssuePhase('preview');
    } else {
      handlealertClick('Could not generate a fix — issue logged for the team', 'warning');
      closeIssueModal();
    }
  } catch (err) {
    console.error('report-issue failed', err);
    handlealertClick('Could not process — issue logged for the team', 'warning');
    closeIssueModal();
  } finally {
    setIssueBusy(false);
  }
};

const applyIssueFix = async () => {
  if (!issuePreview) return;
  if (!confirmOtherVisitWrite('Applying these changes')) return;
  // Write only the sections shown in the preview; untouched (or blanked)
  // sections are never sent, so they cannot be overwritten unseen.
  const changedDict = {};
  for (const s of issueChangedSections()) changedDict[s.key] = issuePreview[s.key];
  if (Object.keys(changedDict).length === 0) return;
  setIssueBusy(true);
  try {
    const fixRes = await blinkscribeapi.put('/v1/recording/category/update', {
      file_name: data?.audiolink,
      context_dict: changedDict,
    }, { timeout: 30000 });
    const localOnly = savedLocallyNotice(fixRes);
    if (issueFeedbackId) {
      blinkscribeapi.put(`/v1/note-feedback/${issueFeedbackId}/action`,
        { action: 'auto_fixed_confirmed' }).catch(() => {});
    }
    handlealertClick(localOnly || (issueSource === 'voice' ? 'Voice edits applied' : 'Fix applied to the note'), localOnly ? 'warning' : 'success');
    closeIssueModal();
    await fetchData();
  } catch (err) {
    console.error('apply issue fix failed', err);
    handlealertClick(issueSource === 'voice' ? 'Could not apply the voice edits — please retry'
      : 'Could not apply the fix — issue stays logged', 'error');
  } finally {
    setIssueBusy(false);
  }
};

const rejectIssueFix = async () => {
  if (issueFeedbackId) {
    blinkscribeapi.put(`/v1/note-feedback/${issueFeedbackId}/action`,
      { action: 'fix_rejected' }).catch(() => {});
  }
  handlealertClick(issueSource === 'voice' ? 'Voice edits discarded — note unchanged'
    : 'Fix discarded — issue stays logged for the team', 'info');
  closeIssueModal();
};

const stopRecording = async () => {
  ismanualstop.current=true
  ismanualrecordstart.current=false
  if (recorderRef.current) {
    recorderRef.current.stopRecording(() => {
      recorderRef.current = null;
    });
  }

  if (audioStreamRef.current) {
    audioStreamRef.current.getTracks().forEach((track) => track.stop());
    audioStreamRef.current = null;
  }

  if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
    wsRef.current.close(1000, "Recording stopped by user");
  }

  stopTimer();
  setElapsedTime(0);
 setIsRecording(false)
 setIsIndRecord(false)
 setRecordingField('')
 if (isVoiceEdit) {
   setIsVoiceEdit(false)
   handlealertClick('Processing your edits...', 'info')
   setIsLoading(true)
   // Poll for the edit recording to finish processing, then refresh
   const poll = async () => {
     for (let i = 0; i < 40; i++) { // 40 x 3s = 2min max
       await new Promise(r => setTimeout(r, 3000));
       try {
         const res = await blinkscribeapi.post(
           `/v1/patient/${config?.patientid}/recording/details`,
           { filter_array: { date_filter: { start_date: new Date().toISOString().slice(0,10), end_date: new Date().toISOString().slice(0,10) } } }
         );
         const records = res?.data || [];
         if (Array.isArray(records)) {
           const editRec = records.find(r => r.audiolink?.includes('_edit') && r.transcriptionstatus === 'Summarized');
           if (editRec) {
             await fetchData();
             handlealertClick('Voice edits applied', 'success');
             break;
           }
         }
       } catch (_) {}
     }
     setIsLoading(false);
   };
   poll();
 } else {
   handlealertClick('Recording Has Been Completed','success')
   setTimeout(() => {
       indref.current=false
      recordingfieldref.current=''
    if (onDone) { onDone(); }
    else { navigate("/landing"); }
   }, 1500);
 }
};
const onExit=()=>{
  if(ismanualrecordstart.current){
    // stopmanualRecording()
  }
  stopRecording()
setIsexitModal(false)
}
const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = () => {
      resolve(reader.result.split(",")[1]);
    };
    reader.onerror = (error) => reject(error);
  });
};
const onDelete=async()=>{
  setDeleteConfirmationModal(true)

}
const deleteStream=async()=>{
  try {
   setIsLoading(true)
    const response=await blinkscribeapi.post(`/v1/recording/streaming/cancel?stream_filename=${streamfilename}`)
    if(response.status===200){ 
      stopRecording()    
      setDeleteConfirmationModal(false)
handlealertClick('Your Recording is Successfully cancelled', 'error')
    }else{
      setDeleteConfirmationModal(false)
    }
    if(      blocker.current=true){
      blocker.current=true
    //   stopmanualRecording()
    }
  } catch (error) {
    console.log(error)
  }finally{
   setIsLoading(false)

  }
}

if (!isLoading && jsonData && Object.keys(jsonData).length == 0) {
  if (embedded) {
    return (
      <div className="flex flex-col items-center justify-center h-full text-center text-gray-600 py-20">
        <p className="text-lg font-semibold">No document found</p>
        <p className="text-sm mt-2">Please try again or come back later.</p>
      </div>
    );
  }
  return createPortal(
<div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
  onClick={(e) => { if (e.target === e.currentTarget) setIsEditScreen(false); }}
>
  <div className="bg-white dark:bg-gray-800 rounded-[20px] shadow w-full max-w-[90%] min-w-[90%] min-h-[90vh] max-h-[90vh] overflow-y-auto px-4 custom-scrollbar relative">
    
    {/* Close icon */}
    <div
      className="absolute top-4 right-4 cursor-pointer"
      onClick={() => setIsEditScreen(false)}
    >
      {crossicon}
    </div>

    {/* If no data */}
    {jsonData && Object.keys(jsonData).length === 0 && (
      <div className="flex flex-col items-center justify-center h-full text-center text-gray-600 dark:text-gray-300 py-20">
        <p className="text-lg font-semibold">No document found</p>
        <p className="text-sm mt-2">Please try again or come back later.</p>
      </div>
    )}

  </div>
</div>

  , document.body);
}


  // Portaled to <body>: rendered inside the chart DOM, an ancestor CSS
  // transform hijacks position:fixed, so on smaller screens the overlay
  // anchored to the wrong box and the header/X clipped off-screen with no
  // way to scroll to them (QA 2026-08-26). Same trap as the Add Notes modal.
  // Embedded mode skips the portal AND the backdrop — the host (visit
  // modal tab) supplies the frame, scrolling, and close affordance.
  const editBody = (
  <>
<div className={embedded ? "w-full" : "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"}
  onClick={(e) => {
    if (embedded) return;
    // Backdrop click closes (QA 2026-08-26) — but never mid voice edit,
    // that would abandon the recording.
    if (e.target !== e.currentTarget) return;
    if (isVoiceRecording) { handlealertClick('Voice edit in progress — use Stop & Apply first', 'info'); return; }
    setIsEditScreen(false);
  }}
>
  <div className={embedded
      ? "bg-white w-full px-4"
      : "bg-white dark:bg-gray-800 rounded-[20px] shadow w-full min-w-[90%] min-h-[70vh]  max-w-[90%] max-h-[90vh] custom-scrollbar overflow-y-auto  px-4 "}>
   
    <div className="flex items-center justify-center w-full h-auto mt-4" 
   
    >
      <div className=" mb-2 w-full flex flex-col justify-between items-center relative h-min-[150px] h-auto   pb-3 ">
        <div className='w-full flex items-center justify-between'>
          {/* Embedded: the visit modal already shows a title and its own ✕ —
              repeating them here reads as a second stacked dialog. */}
          {!embedded && <div className='text-[#111827] text-[20px] font-semibold'>Edit</div>}
          {mergePending && (
            <div className="flex-1 mx-4 rounded-md bg-amber-50 border border-amber-300 text-amber-800 text-[13px] px-3 py-1.5">
              A newer recording is still being merged into this note - content may be incomplete. Check back in a few minutes.
            </div>
          )}
        {!embedded && (
        <div className='cursor-pointer'   onClick={(()=>{setIsEditScreen(false)})} >
         {crossicon}
        </div>
        )}
        </div>
        {isOtherVisitNote && (
          <div role="alert" className="w-full mt-2 rounded-lg border-2 border-red-500 bg-red-50 text-red-800 px-4 py-2 text-left">
            <div className="text-[15px] font-bold">
              ⚠ This is the note from {otherVisitDate || 'an earlier date'} (a different visit)
            </div>
            <div className="text-[13px] mt-0.5">
              {"It is not the note for the visit open in the chart. Saving, voice edits, fixes and " +
                "sign-off here change that earlier visit's note and re-post it to its Athena encounter."}
              {otherVisitConfirmed
                ? ' You confirmed you want to change it.'
                : ' You will be asked to confirm before anything is changed.'}
            </div>
          </div>
        )}

{/* <div className='w-full relative flex flex-col gap-2 sm:flex-row sm:gap-0 justify-between items-center'>
        
<div className='w-full flex justify-center items-center gap-4'>
          <div
      className="relative flex justify-center items-center w-[70px] h-[70px] rounded-full"
      style={circleStyle}
    >
      <div className="flex justify-center items-center w-[60px] h-[60px] bg-[#FAFAF9] rounded-full">
        <img
           src={userr?.profile_photo||'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg=='}
                        alt='profile'
                        onError={(e) => e.target.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg=='}
        className="flex justify-center items-center w-[50px] h-[50px] bg-[#C4C4C4] rounded-full"/>
      </div>
   
    </div>
          <div class="text-start font-sans font-medium">
    {userr?.patient_name?<div class="text-sm text-gray-600">{userr?.patient_name}</div>:<></>}
    {userr?.patientid?<div class="text-sm text-gray-600">{userr?.patientid}</div>:<></>}
    {userr?.dob ? (
  <div className="text-sm text-gray-600">
    {new Date(userr.dob).toLocaleDateString('en-GB')}
  </div>
) : (
  <></>
)}

{(() => {
  const parse = (v) => { const d = v ? new Date(v) : null; return d && !isNaN(d.getTime()) ? d : null; };
  // Date of Service = the appointment date; fall back to the recording date.
  const dos = parse(userr?.startdate) || parse(data?.ts);
  return dos ? (
    <div className="text-sm font-semibold text-[#1D2951] mt-1">
      Date of Service: {dos.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
    </div>
  ) : null;
})()}
{(() => {
  const d = data?.ts ? new Date(data.ts) : null;
  return d && !isNaN(d.getTime()) ? (
    <div className="text-xs text-gray-500">
      Recorded: {d.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' })}
    </div>
  ) : null;
})()}



          </div>
          </div>
          <div className='flex min-w-[400px] gap-4 items-end justify-center'>
           <div 
        onClick={()=>{handleCopyallText()}}
        className="flex flex-row h-auto sm:h-9  gap-2  items-center  cursor-pointer p-2 rounded-md border border-gray-100 bg-white shadow-[0px_4px_16px_0px_rgba(20,25,26,0.08)]">
        
            <img style={{ width: '13px', height: '13px' }} src={Copyall} alt="&/" /> 
            <div className="text-xs sm:text-sm"> Copy All</div>
        
        </div>
        <div className='flex flex-col gap-4 items-center justify-center'>
     
     
        {isIndRecord ? (
  <div>{!mydata.isStreaming ?
 <IndividualRecording screenname={recordingField}
 setIndIsRecording={setIndIsRecording}
 submitIndAudio={submitIndAudio}
 setToastmsg={setToastObject}
 setToast={setToast}
 setIsdelted={setIndIsDeletedAudio}
 />:<ArcheiveStreaming
 setIsexitModal={setIsexitModal}
stopRecording={stopRecording}
elapsedTime={elapsedTime}
formatTime={formatTime}
togglePause={togglePause}
isPaused={isPaused}
setIsPaused={setIsPaused}
stopTimer={stopTimer}
pausedref={pausedref}
audioStreamRef={audioStreamRef}
onDelete={onDelete}
 />}
   </div>
) : isRecording ? (
  !mydata.isStreaming ?
  <ArchiveRecordingScreen
    setIsRecording={setIsRecording}
    submitAudio={submitAudio}
    setToastmsg={setToastObject}
    setToast={setToast}
    setIsdelted={setIsdelted}
  />:<ArcheiveStreaming
   setIsexitModal={setIsexitModal}
  stopRecording={stopRecording}
  elapsedTime={elapsedTime}
  formatTime={formatTime}
  togglePause={togglePause}
  isPaused={isPaused}
  setIsPaused={setIsPaused}
  stopTimer={stopTimer}
  pausedref={pausedref}
  audioStreamRef={audioStreamRef}
  onDelete={onDelete}
   />
) : (
  <>
    <div
      onClick={async () => {
        if(mydata.isOpen){
          setAlertMessage('Recording already in progress');
          setSeverity('info'); // Change severity as needed
          setOpen(true);
        return
        }
        // Visit gate + consent before any audio (owner rule 2026-09-29).
        if (!(await guardNoteRecording())) return;
        if(mydata.isStreaming ){
          startRecording()
        }
        setIsRecording(true);
        setIsVoiceEdit(true);
        setIsdelted(false);
        handlealertClick('Recording Started — speak your edits');
      }}
      className="relative flex items-center justify-center"
    >
      <div className="flex items-center justify-center w-[70px] h-[70px] rounded-full bg-gradient-to-br from-[#E17954] to-[#C0392B] shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-105">
        <MicIcon style={{ color: '#fff', fontSize: '32px' }} />
      </div>
      <span className="text-xs text-[#E17954] font-medium mt-1">Edit with Voice</span>
    </div>

  </>
)}
        </div>
       


        </div>

        <div className=''>
  {data?.transcriptionstatus === 'Summarized' && (
    <button
      onClick={() => handleSignoff()}
      disabled={isbuttonloading}
      className={`px-6 py-2 rounded-lg text-white text-[10px] whitespace-nowrap ${
        isbuttonloading ? 'bg-gray-500 cursor-not-allowed opacity-50' : 'bg-[#1C2A3A] cursor-pointer opacity-100'
      }`}
    >
      {isbuttonloading ? 'Signing Off...' : 'Sign Off'}
    </button>
  )}
  {data?.transcriptionstatus === 'APPROVED' && (
    <span className='inline-flex items-center gap-2'>
    <span className='px-6 py-2 rounded-lg text-white text-[10px] whitespace-nowrap bg-[#059669] inline-flex items-center gap-1 cursor-default'>
      ✓ Signed Off
    </span>
    <button
      type="button"
      onClick={() => handleNoteDocument('download')}
      disabled={!noteDocReady}
      title={noteDocTitle('download')}
      className={`px-3 py-2 rounded-lg text-[10px] whitespace-nowrap border ${
        noteDocReady ? 'border-[#059669] text-[#059669] cursor-pointer' : 'border-gray-300 text-gray-400 cursor-not-allowed'
      }`}
    >
      {noteDocLabel('download')}
    </button>
    <button
      type="button"
      onClick={() => handleNoteDocument('print')}
      disabled={!noteDocReady}
      title={noteDocTitle('print')}
      className={`px-3 py-2 rounded-lg text-[10px] whitespace-nowrap border ${
        noteDocReady ? 'border-[#059669] text-[#059669] cursor-pointer' : 'border-gray-300 text-gray-400 cursor-not-allowed'
      }`}
    >
      {noteDocLabel('print')}
    </button>
    </span>
  )}
</div>


        <div className='flex w-full justify-end items-center'>
          <div className='flex items-center gap-4 sm:ml-14'>
          <DashboardOutlinedIcon
      onClick={()=>setView(2)}
        style={{
          color: view===2 ? 'black' : 'grey', // Change the color based on isGridView
          cursor: 'pointer',
           fontSize:"26px"
        }}
      />
          <SplitscreenOutlinedIcon
      onClick={()=>setView(1)}
        style={{
          color: view===1 ? 'black' : 'grey', // Change the color based on isGridView
          cursor: 'pointer',
           fontSize:"26px"
        }}
      />
  <MenuIcon
  onClick={()=>{setView(0)}}
        style={{
          color: view===0?'black' : 'grey', // Change the color based on isGridView
          cursor: 'pointer',
          fontSize:"30px"
        }}
      />
  
      
  </div>
  </div>


</div> */}

{/* ── Edit Header with Voice Edit Mic ── */}
<div className="w-full flex items-center justify-between px-4 py-3 mb-2" style={{ background: "rgba(225,121,84,0.04)", borderRadius: "8px", border: "1px solid rgba(225,121,84,0.15)" }}>
  <div className="flex items-center gap-3">
    {isVoiceRecording ? (
      <div className="flex items-center gap-3">
        <div
          onClick={stopVoiceEdit}
          className="flex items-center justify-center w-[48px] h-[48px] rounded-full bg-red-500 shadow-md cursor-pointer animate-pulse"
        >
          <div className="w-[18px] h-[18px] bg-white rounded-sm" />
        </div>
        <div>
          <div className="text-sm font-semibold text-red-600">Recording...</div>
          <div className="text-[11px] text-[#6B7280]">Click to stop and apply edits</div>
        </div>
      </div>
    ) : (
      <div
        onClick={startVoiceEdit}
        className="flex items-center gap-3 cursor-pointer group"
      >
        <div className="flex items-center justify-center w-[48px] h-[48px] rounded-full bg-gradient-to-br from-[#E17954] to-[#C0392B] shadow-md group-hover:shadow-lg transition-all duration-200 group-hover:scale-105">
          <MicIcon style={{ color: '#fff', fontSize: '24px' }} />
        </div>
        <div>
          <div className="text-sm font-semibold text-[#1D2951]">Edit with Voice</div>
          <div className="text-[11px] text-[#6B7280]">Speak your changes to update the note</div>
        </div>
      </div>
    )}
  </div>
  <div className="flex items-center gap-3">
    <button
      onClick={() => setIssueModal(true)}
      disabled={isVoiceRecording}
      title="Report a problem with this note — fix it now or log it for the team"
      className={`px-3 py-1.5 rounded-lg text-xs whitespace-nowrap border ${
        isVoiceRecording
          ? 'border-gray-300 text-gray-400 cursor-not-allowed'
          : 'border-[#E17954] text-[#E17954] hover:bg-[#E17954] hover:text-white cursor-pointer'
      }`}
    >
      ⚑ Report issue
    </button>
    {data?.transcriptionstatus === 'Summarized' && (
      <button
        onClick={() => handleSignoff()}
        disabled={isbuttonloading || isVoiceRecording}
        title={isVoiceRecording ? 'Finish the voice edit first' : undefined}
        className={`px-4 py-1.5 rounded-lg text-white text-xs whitespace-nowrap ${
          (isbuttonloading || isVoiceRecording) ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#1C2A3A] hover:bg-[#2D3A4A] cursor-pointer'
        }`}
      >
        {isbuttonloading ? 'Signing Off...' : 'Sign Off'}
      </button>
    )}
    {data?.transcriptionstatus === 'APPROVED' && (
      <>
        <span className='px-4 py-1.5 rounded-lg text-white text-xs whitespace-nowrap bg-[#059669] inline-flex items-center gap-1 cursor-default'>
          ✓ Signed Off
        </span>
        {/* Download / Print of the signed note's PDF (owner request 2026-10-02).
            Same style family as "Report issue"; disabled until the note has a
            document on file and while a fetch is running. */}
        <button
          type="button"
          onClick={() => handleNoteDocument('download')}
          disabled={!noteDocReady}
          title={noteDocTitle('download')}
          className={`px-3 py-1.5 rounded-lg text-xs whitespace-nowrap border ${
            noteDocReady
              ? 'border-[#059669] text-[#059669] hover:bg-[#059669] hover:text-white cursor-pointer'
              : 'border-gray-300 text-gray-400 cursor-not-allowed'
          }`}
        >
          {noteDocLabel('download')}
        </button>
        <button
          type="button"
          onClick={() => handleNoteDocument('print')}
          disabled={!noteDocReady}
          title={noteDocTitle('print')}
          className={`px-3 py-1.5 rounded-lg text-xs whitespace-nowrap border ${
            noteDocReady
              ? 'border-[#059669] text-[#059669] hover:bg-[#059669] hover:text-white cursor-pointer'
              : 'border-gray-300 text-gray-400 cursor-not-allowed'
          }`}
        >
          {noteDocLabel('print')}
        </button>
      </>
    )}
    {/* Only rendered mid voice edit, as "Stop & Apply" (a provider pressed
        Save instead of the stop circle and got a confusing half-flow —
        QA 2026-08-26, Dr. Adupa). Outside a recording this screen has
        nothing to save (voice edits open a review on stop, section editors save
        themselves), so the idle Save button was dropped (QA 2026-08-26). */}
    {isVoiceRecording && (
      <button
        onClick={stopVoiceEdit}
        disabled={isSaving}
        className={`px-4 py-1.5 rounded-lg text-white text-xs whitespace-nowrap ${
          isSaving ? 'bg-gray-400 cursor-not-allowed' : 'bg-red-500 hover:bg-red-600 cursor-pointer animate-pulse'
        }`}
      >
        {isSaving ? 'Saving...' : 'Stop & Apply'}
      </button>
    )}
  </div>
</div>

{Array.isArray(data?.note_json?.applied_instructions) && data.note_json.applied_instructions.length > 0 && (
  <div className="w-full flex flex-wrap items-center gap-1.5 mt-2 px-1">
    <span className="text-[11px] font-semibold text-[#6B7280]">AI instructions applied:</span>
    {data.note_json.applied_instructions.map((ai, i) => (
      <span
        key={i}
        title={`${ai.reason || ""} — click to view/edit (changes apply to future notes)`}
        onClick={() => setInstrModal(ai.name)}
        className="px-2 py-0.5 rounded-full text-[10px] font-semibold bg-[#EFF6FF] text-[#1D4ED8] border border-[#93C5FD] cursor-pointer whitespace-nowrap"
      >
        {ai.name}
      </span>
    ))}
  </div>
)}
{instrModal !== null && (
  <NoteInstructionsModal open onClose={() => setInstrModal(null)} initialName={instrModal} />
)}

{view===0?
<div className='w-full mt-[4%] items-center h-auto  justify-center flex flex-col gap-4'>
{jsonData.map((section, idx) => (
<>
{summaryjson?.[section.placeholder?.toLowerCase()]?.length > 0 ?
<div  
 onClick={()=>{
  setSectionData(section)
  setPopUp(true)
}}

key={idx} className="flex flex-col cursor-pointer sm:flex-row justify-between items-center w-full sm:w-[80%] h-auto sm:h-20 rounded-lg shadow-md pr-0 sm:pr-4 border-l-4 border-[#A2C6FD] border-t border-b border-t-gray-400 border-b-gray-400 bg-white">
  <div className="flex items-center justify-center w-full sm:w-[20%] sm:min-w-[20%] sm:max-w-[20%]  bg-blue-100 p-4 ">
    <h1 className="text-sm font-bold  text-blue-600">{section.label
    ? section.label
        .toLowerCase() // Ensure all letters are lowercase first
        .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
    : ''}</h1>
  </div>
  <div className='w-full flex justify-start'>

  <div 
  className="mt-2 font-sans text-[#374151] px-4 text-left"
  dangerouslySetInnerHTML={{
    __html: summaryjson?.[section.placeholder?.toLowerCase()]?.length > 50
      ? noteTextToHtml(`${summaryjson[section.placeholder?.toLowerCase()].substring(0, 50)}...`)
      : noteTextToHtml(summaryjson[section.placeholder?.toLowerCase()])
  }}
></div>

  </div>


  <div className='flex gap-4 justify-end items-center w-full sm:min-w-[20%] sm:max-w-[20%]'>
  {['review of systems', 'physical examination'].includes(section.label) ? (
    <div className={`inline-block px-3 mr-6 py-1 text-xs rounded-full shadow-md ${summaryjson[section.placeholder?.toLowerCase()].replace(/\s|\./g, '') === 'Normal' ? 'text-green-700 bg-green-200' : 'text-red-700 bg-red-200'}`}>
        {summaryjson[section.placeholder?.toLowerCase()].replace(/\s|\./g, '') === 'Normal' ?'Normal':'Abnormal'}
    </div>
) : null}

<div className='flex gap-4 mr-2 items-center justify-center flex-row '>
{section?.label==='doctor instructions'?<ShareOutlinedIcon
  onClick={(event) => {
    event.stopPropagation(); // Prevent event from bubbling up
    setSelectedCard(section);
    setIsShareModal(true);
  }}
  sx={{
    fontSize: "18px",
    color: "#676767",
    cursor: "pointer",
    marginTop: "2rem",
  }}
/>
:<></>}
<FontAwesomeIcon 
      onClick={()=>{
        setSectionData(section)
           setFields(prevFields => ({ ...prevFields, [section.key]: formatToText(section.value)}))
                      
        setPopUp(true)
      }}
      icon={faUpRightFromSquare} className="text-[#7E7E7E] mt-8 cursor-pointer" />


</div>
  </div>

</div>
:<></>}
</>
))
}</div>:
(view===1?
<>
<div className="w-full mt-[4%] flex flex-col justify-center gap-4">
  
  {jsonData.map((section, idx) => (
   <>{
    summaryjson?.[section.placeholder?.toLowerCase()]?.length > 0 ?
     <div
      key={idx}
      className="flex flex-col justify-between items-center w-auto max-w-full"
      style={{
        borderRadius: "8px",
        border: "1px solid rgba(162, 198, 253, 0.40)",
        background: "#FFF",
        boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
        flex: '1 0 auto', // Ensures it grows dynamically
      }}
    >
      <div className="flex items-center justify-between w-full h-10 px-4 bg-blue-100 p-0 rounded-md">
        <h1 className="text-sm font-bold text-[#262629]">
          {section.label
            ? section.label
                .toLowerCase() // Ensure all letters are lowercase first
                .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
            : ''}
        </h1>
        <div className='flex gap-4 items-center'>
        {section?.label==='doctor instructions'?<ShareOutlinedIcon
         onClick={()=>{
          setSelectedCard(section)
          setIsShareModal(true)
        }}
        sx={{fontSize:"18px",color:"#676767",cursor:"pointer"}}
        />:<></>}
        

        <FontAwesomeIcon 
           onClick={()=>{
            setSectionData(section)
               setFields(prevFields => ({ ...prevFields, [section.key]: formatToText(section.value)}))
                          setPopUp(true);
           
          }}
        icon={faUpRightFromSquare} className="text-[#7E7E7E] cursor-pointer" />
        </div>
      </div>
      <div className="w-full flex justify-start">
      <div 
  className="mt-2 font-sans text-[#374151] px-4 text-left"
  dangerouslySetInnerHTML={{
    __html: summaryjson?.[section.placeholder?.toLowerCase()]?.length > 100
      ? noteTextToHtml(`${summaryjson[section.placeholder?.toLowerCase()].substring(0, 100)}...`)
      : noteTextToHtml(summaryjson[section.placeholder?.toLowerCase()])
  }}
></div>
      </div>
      <div className="flex mb-4 justify-end items-center w-full px-4">
      {['review of systems', 'physical examination'].includes(section.label) ? (
    <div className={`inline-block px-3 py-1 text-xs rounded-full shadow-md ${summaryjson[section.placeholder?.toLowerCase()].replace(/\s|\./g, '') === 'Normal' ? 'text-green-700 bg-green-200' : 'text-red-700 bg-red-200'}`}>
        {summaryjson[section.placeholder?.toLowerCase()].replace(/\s|\./g, '') === 'Normal' ?'Normal':'Abnormal'}
    </div>
) : null}
      </div>
    </div>:<></>
}</>
  ))}

</div>




</>:<>
{/* Redesigned grid: HPI + A/P show full text, others show summary */}
<div className="w-full mt-[1%] grid grid-cols-1 sm:grid-cols-3 gap-4">
  {jsonData.map((section, idx) => {
    const key = section.key;
    const isFullText = ['hpi', 'assessment_plan'].includes(key);
    const summaryOnly = ['physical_examination', 'review_of_systems', 'doctor_instructions'].includes(key);
    const hasContent = isFullText
      ? section.value && String(section.value).trim().length > 0
      : summaryjson?.[section.placeholder?.toLowerCase()]?.length > 0;

    if (!hasContent) return null;

    // HPI and Assessment/Plan get full width; CC/PE/ROS share top row
    const customClasses = isFullText
      ? "col-span-3 min-h-[140px]"
      : (key === 'chief_complaint' || key === 'physical_examination' || key === 'review_of_systems')
        ? "col-span-3 sm:col-span-1 min-h-[60px]"
        : "col-span-3 sm:col-span-1 min-h-[100px]";

    // Display text: full note_json for HPI/AP, summary for others
    const displayText = isFullText
      ? (typeof section.value === 'string' ? section.value : Array.isArray(section.value) ? section.value.join('\n') : JSON.stringify(section.value))
      : summaryjson?.[section.placeholder?.toLowerCase()] || '';

    const truncated = !isFullText && displayText.length > 100
      ? displayText.substring(0, 100) + '...'
      : displayText;

    return (
      <div
        key={idx}
        className={`flex flex-col justify-start items-start w-auto max-w-full ${customClasses}`}
        style={{
          borderRadius: "8px",
          border: isFullText ? "1px solid rgba(225, 121, 84, 0.30)" : "1px solid rgba(162, 198, 253, 0.40)",
          background: "#FFF",
          boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
          flex: "1 0 auto",
        }}
      >
        <div className="flex items-center justify-between w-full h-10 px-4 p-0 rounded-md"
          style={{ background: isFullText ? 'rgba(225, 121, 84, 0.08)' : 'var(--color-orange-615, rgba(225, 121, 84, 0.05))' }}
        >
          <h1 className={`text-sm font-semibold ${isFullText ? 'text-[#1D2951]' : 'text-[#E17954]'}`}>
            {section.label
              ? section.label
                  .toLowerCase()
                  .replace(/\b\w/g, (char) => char.toUpperCase())
              : ""}
          </h1>
          <div className='flex items-center gap-4'>
            {section?.label === 'doctor instructions' ? <ShareOutlinedIcon
              onClick={() => { setSelectedCard(section); setIsShareModal(true); }}
              sx={{ fontSize: "18px", color: "#E17954", cursor: "pointer" }}
            /> : null}
            <FontAwesomeIcon
              onClick={() => {
                setSectionData(section);
                setFields(prevFields => ({ ...prevFields, [section.key]: formatToText(section.value) }));
                setPopUp(true);
              }}
              icon={faUpRightFromSquare}
              className="text-[#E17954] cursor-pointer"
            />
          </div>
        </div>
        <div className="w-full flex justify-start">
          {key === 'assessment_plan' ? (
            <div className="mt-2 px-4 pb-3 w-full max-h-[380px] overflow-y-auto hover-scrollbar"
              style={{ scrollbarWidth: 'thin' }}>
              <APDiagnosisList entries={apEntries} onRemove={handleRemoveDx} />
            </div>
          ) : (
          <div
            className={`mt-2 font-sans text-[#374151] px-4 pb-3 text-left ${isFullText ? 'text-sm leading-relaxed whitespace-pre-wrap max-h-[300px] overflow-y-auto hover-scrollbar' : ''}`}
            style={isFullText ? { scrollbarWidth: 'thin', scrollbarColor: 'transparent transparent' } : undefined}
            onMouseEnter={(e) => { if (isFullText) e.currentTarget.style.scrollbarColor = '#d1d5db transparent'; }}
            onMouseLeave={(e) => { if (isFullText) e.currentTarget.style.scrollbarColor = 'transparent transparent'; }}
            dangerouslySetInnerHTML={{
              __html: noteTextToHtml(truncated)
            }}
          ></div>
          )}
        </div>
        <div className="flex mb-2 justify-end items-center w-full px-4">
          {['review of systems', 'physical examination'].includes(section.label) ? (
            <div className={`inline-block px-3 py-1 text-xs rounded-full shadow-md ${
              summaryjson[section.placeholder?.toLowerCase()]?.replace(/\s|\./g, '') === 'Normal'
                ? 'text-green-700 bg-green-200' : 'text-red-700 bg-red-200'
            }`}>
              {summaryjson[section.placeholder?.toLowerCase()]?.replace(/\s|\./g, '') === 'Normal' ? 'Normal' : 'Abnormal'}
            </div>
          ) : null}
        </div>
      </div>
    );
  })}

  {/* Current Medications — read-only reference, last cell of the bento grid.
      Sourced from note_json; NOT part of jsonData/order, so it can never be
      edited or enter changedFields on save. */}
  {(() => {
    const meds = data?.note_json?.current_medications;
    const items = Array.isArray(meds)
      ? meds
      : (typeof meds === 'string' && meds.trim()
          ? meds.split('\n').map(s => s.trim()).filter(Boolean)
          : (meds ? [meds] : []));
    if (!items.length) return null;
    const fmtMed = (m) => {
      if (typeof m === 'string') return m;
      if (m && typeof m === 'object') {
        const name = m.name || m.medication || m.drug || m.med || '';
        const dose = m.dosage || m.dose || m.strength || '';
        const sig = m.frequency || m.sig || m.instructions || m.route || '';
        const parts = [name, dose, sig].filter(Boolean);
        if (parts.length) return parts.join(' — ');
        const vals = Object.values(m).filter(v => typeof v === 'string' && v.trim());
        return vals.length ? vals.join(' — ') : JSON.stringify(m);
      }
      return String(m);
    };
    return (
      <div
        className="flex flex-col justify-start items-start w-auto max-w-full col-span-3 sm:col-span-1 min-h-[100px]"
        style={{ borderRadius: "8px", border: "1px solid rgba(162, 198, 253, 0.40)", background: "#FFF", boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)", flex: "1 0 auto" }}
      >
        <div className="flex items-center justify-between w-full h-10 px-4 rounded-md" style={{ background: 'var(--color-orange-615, rgba(225, 121, 84, 0.05))' }}>
          <h1 className="text-sm font-semibold text-[#E17954]">Current Medications</h1>
          <span className="text-[10px] font-medium text-[#9CA3AF] italic">Read-only</span>
        </div>
        <ul className="list-disc w-full text-left pl-8 pr-4 py-3 text-sm text-[#374151] leading-relaxed">
          {items.map((m, i) => (<li key={i}>{fmtMed(m)}</li>))}
        </ul>
      </div>
    );
  })()}
</div>






</>
)
}

        {/* <div className='w-full flex justify-center  flex-col items-center'>
        <div className="mt-[6%] w-[90%] grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">
        {jsonData.map((section, idx) => (
     <div
     key={idx}
     className="flex shadow-[0px_2px_13px_#00000040] flex-col p-4 gap-2 w-full max-w-[350px]"
     style={{
       borderRadius: "8px",
       background: "#FFF",
   
     }}
   >
          <div className="flex justify-between w-full">
            <div style={{ fontWeight: 500 }} className="text-xs">{section.label}</div>          
          </div>
          <div className="relative">
          <textarea
  className="w-full custom-scrollbar  max-w-md p-2 font-inter placeholder:text-xs"
  style={{
    borderRadius: "8px",
    border: "1px solid #A2C6FD",
    background: "#FFF",
    boxShadow: "0px 5px 15px 0px rgba(119, 132, 238, 0.30)",
  }}
  rows={8}
  value={fields[section.key]}
  onChange={(e) => handleFieldChange(section.key, e.target.value)}
  placeholder={section.placeholder}
/>
            <div className="absolute right-2 bottom-2">
            
            </div>
          </div>
<div className='w-full flex justify-between items-center'>
<div className='flex items-center gap-4'>
<div>
                <img
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                  src={copydark}
                  alt="Copy"
                  onClick={() => copyToClipboard(fields[section.key])}
                />
              </div>
              <div>
                <img
                  style={{ width: "13px", height: "13px", cursor: "pointer" }}
                  src={printdark}
                  alt="Print"
                  onClick={() => {
                    if (data.transcriptionstatus === 'Processing') {
                      setAlertMessage('Update in process. Hold on!');
                      setSeverity('info'); 
                      setOpen(true);
                      return;
                    }
                    handleSaveIconClick(section.key)}}
                />
              </div>

</div>

<div className="flex items-center gap-2">
              <div   onClick={async ()=>{
                    if(recordingField==section.key){
                      return
                    }
                    if(recordingField){
                      return
                    }
                    if (data.transcriptionstatus === 'Processing') {
                      setAlertMessage('Update in process. Hold on!');
                      setSeverity('info'); 
                      setOpen(true);
                      return;
                    }
                    if(mydata.isOpen){
                      setAlertMessage('Recording already in progress');
                      setSeverity('info'); 
                      setOpen(true);
                    return
                    }
                    // Visit gate + consent before the section recorder opens
                    // (it starts the microphone on mount).
                    if (!(await guardNoteRecording())) return;
                    setRecordingField(section.key)
                    setIsIndRecord(true)
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }} 
                   >
                 <MicIcon 
  fontSize="small" 
  style={{ 
    cursor: "pointer", 
    width: "20px", 
    height: "20px", 
    color: recordingField === section.key ? 'red' : '#000' 
  }} 
/>

              
              </div>
          
            </div>

</div>

        </div>
      ))}

    </div>
</div> */}
       <div className="flex w-full items-start mt-4 justify-start gap-4">
  {data?.transcriptionstatus === 'Summarized' && (
    <button
      onClick={() => handleSignoff()}
      disabled={isbuttonloading}
      style={{
        borderRadius: '6px',
        border: 'var(--stroke-weight-1, 1px) solid var(--color-orange-61, #E17954)',
        background: 'var(--color-white-solid, #FFF)',
      }}
      className={`inline-flex items-center justify-center min-w-[100px] px-2 py-1 text-md font-[Tahoma] text-[#E17954] whitespace-nowrap ${
        isbuttonloading ? 'cursor-not-allowed opacity-50' : 'cursor-pointer opacity-100'
      }`}
    >
      {isbuttonloading ? 'Signing Off...' : 'Sign Off'}
    </button>
  )}
  {data?.transcriptionstatus === 'APPROVED' && (
    <>
      <span
        style={{
          borderRadius: '6px',
          border: 'var(--stroke-weight-1, 1px) solid #059669',
          background: 'var(--color-white-solid, #FFF)',
        }}
        className='inline-flex items-center justify-center min-w-[100px] px-2 py-1 text-md font-[Tahoma] text-[#059669] whitespace-nowrap cursor-default gap-1'
      >
        ✓ Signed Off
      </span>
      {/* Download / Print of the signed note's PDF (owner request 2026-10-02):
          outlined like the Sign Off button this bar shows before signing. */}
      <button
        type="button"
        onClick={() => handleNoteDocument('download')}
        disabled={!noteDocReady}
        title={noteDocTitle('download')}
        style={{
          borderRadius: '6px',
          border: 'var(--stroke-weight-1, 1px) solid #059669',
          background: 'var(--color-white-solid, #FFF)',
        }}
        className={`inline-flex items-center justify-center min-w-[100px] px-2 py-1 text-md font-[Tahoma] text-[#059669] whitespace-nowrap ${
          noteDocReady ? 'cursor-pointer opacity-100' : 'cursor-not-allowed opacity-50'
        }`}
      >
        {noteDocLabel('download')}
      </button>
      <button
        type="button"
        onClick={() => handleNoteDocument('print')}
        disabled={!noteDocReady}
        title={noteDocTitle('print')}
        style={{
          borderRadius: '6px',
          border: 'var(--stroke-weight-1, 1px) solid #059669',
          background: 'var(--color-white-solid, #FFF)',
        }}
        className={`inline-flex items-center justify-center min-w-[100px] px-2 py-1 text-md font-[Tahoma] text-[#059669] whitespace-nowrap ${
          noteDocReady ? 'cursor-pointer opacity-100' : 'cursor-not-allowed opacity-50'
        }`}
      >
        {noteDocLabel('print')}
      </button>
    </>
  )}

  {showNpAttestation && (
    <label
      className="flex items-center gap-2 mr-3 text-sm text-gray-700 cursor-pointer select-none"
      title={ATTESTATION_LINE}
    >
      <input
        type="checkbox"
        checked={npAttested}
        onChange={(e) => handleNpAttestationToggle(e.target.checked)}
        className="h-4 w-4 cursor-pointer accent-[#E17954]"
      />
      <span>Discussed with Dr. Madhu</span>
    </label>
  )}
  <button
    onClick={handleSaveButtonClick}
    disabled={isSaving}
    style={{
      borderRadius: '6px',
      background: isSaving ? '#9CA3AF' : 'var(--color-orange-61, #E17954)',
    }}
    className={`inline-flex items-center justify-center min-w-[100px] px-2 py-1 text-md font-[Tahoma] text-white ${
      isSaving ? 'cursor-not-allowed opacity-70' : ''
    }`}
  >
    {isSaving ? 'Saving...' : 'Save'}
  </button>
</div>

      </div>
    </div>


    {popup ? (
  <>
    {/* Dark Background Overlay */}
    <div
      className="fixed inset-0 bg-black bg-opacity-50"
      onClick={() => setPopUp(false)} // Close popup on clicking outside
    ></div>

    {/* Popup Content */}
    <div
          className="flex flex-col h-full shadow-[0px_2px_13px_#00000040] p-4 gap-2 w-full max-w-[550px] sm:max-w-[60%] sm:min-h-[400px] sm:h-[80vh]  sm:max-h-[90vh] bg-white fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
      style={{
        borderRadius: "8px",
        background: "white",
        // height: "80vh", // Fixed height
        // maxHeight: "90vh", // Prevents overflow on smaller screens
        overflow: "hidden", // Prevents popup from growing beyond fixed height
      }}
    >
      {/* Section Label */}
      <div className="flex justify-between w-full mb-4">
        <div style={{ fontWeight: 500 }} className="text-sm">
          {sectiondata.label
            ? sectiondata.label
                .toLowerCase()
                .replace(/\b\w/g, (char) => char.toUpperCase())
            : ""}
        </div>

        {/* {["review of systems", "physical examination"].includes(
          sectiondata.label
        ) ? (
          <div className="inline-block px-3 py-1 text-xs text-[#991B1B] bg-[#FEE2E2] rounded-full shadow-md">
            {summaryjson?.[sectiondata.placeholder]?.length
              ? "Abnormal"
              : "Normal"}
          </div>
        ) : null} */}

        <CloseIcon
          style={{ cursor: "pointer", color: "#000" }}
          onClick={() => setPopUp(false)}
        />
      </div>

      {/* Textarea */}
      <div className="h-full flex-grow overflow-hidden">
        {/* <textarea
          className="w-full h-full custom-scrollbar max-w-[90%] p-2 font-inter placeholder:text-xs"
          style={{
            borderRadius: "8px",
            border: "1px solid #A2C6FD",
            background: "#FFF",
            boxShadow: "0px 5px 15px 0px rgba(119, 132, 238, 0.30)",
          }}
          rows={12}
          value={fields[sectiondata.key]}
          onChange={(e) => handleFieldChange(sectiondata.key, e.target.value)}
          placeholder={sectiondata.placeholder}
        />  */}
        <ReactQuill
      className="w-full text-start flex-grow custom-scrollbar p-2 font-inter note-section-editor"
      style={{
        borderRadius: "8px",
        border: "1px solid #A2C6FD",
        background: "#FFF",
        boxShadow: "0px 5px 15px 0px rgba(119, 132, 238, 0.30)",
        minHeight: "200px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
          overflow:"hidden"
      }}
        value={noteTextToHtml(fields[sectiondata.key])}
        onChange={(value) => handleFieldChange(sectiondata.key, value)}
        placeholder={sectiondata.placeholder}
        modules={{
          toolbar: [
            [{ font: [] }], // Font family dropdown
            [{ size: ["small", false, "large", "huge"] }], // Font size
            [{ header: [1, 2, 3, 4, 5, 6, false] }], // Headers
            ["bold", "italic", "underline", "strike"], // Text styles
            [{ color: [] }, { background: [] }], // Text color and background
            [{ script: "sub" }, { script: "super" }], // Subscript & Superscript
            [{ list: "ordered" }, { list: "bullet" }], // Lists
            [{ indent: "-1" }, { indent: "+1" }], // Indentation
            [{ align: [] }], // Text alignment
            ["blockquote", "code-block"], // Blockquote & Code block
            // ["link", "image", "video"], // Media embeds
            ["clean"], // Clear formatting
          ],
        }}
        formats={[
          "font", "size", "header",
          "bold", "italic", "underline", "strike",
          "color", "background",
          "script", "sub", "super",
          "list", "bullet", "indent",
          "align", "blockquote", "code-block",
          // "link", "image", "video"
        ]}
      />
      </div>

      {/* Footer Section */}
      <div className="w-full flex justify-between items-center py-2">
        <div className="flex items-center gap-4">
          <img
            style={{ width: "18px", height: "18px", cursor: "pointer" }}
            src={copydark}
            alt="Copy"
            onClick={() => copyToClipboard(fields[sectiondata.key])}
          />
        </div>
        <button
          onClick={() => handleSaveIconClick(sectiondata.key)}
          disabled={isSaving}
          className={`flex items-center gap-2 px-6 py-2 rounded-lg text-white text-sm font-medium transition-colors shadow-md ${
            isSaving ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#E17954] hover:bg-[#C0392B] cursor-pointer'
          }`}
        >
          <FontAwesomeIcon icon={faSave} style={{ fontSize: "16px" }} />
          {isSaving ? 'Saving...' : 'Save'}
        </button>
      </div>

        {/* Mic Icon */}
        {/* <div className="flex items-center gap-2">
          <div
            onClick={() => {
              if (recordingField === sectiondata.key) {
                return;
              }
              if (recordingField) {
                return;
              }
              if (data.transcriptionstatus === "Processing") {
                setAlertMessage("Update in process. Hold on!");
                setSeverity("info");
                setOpen(true);
                return;
              }
              if (mydata.isOpen) {
                setAlertMessage("Recording already in progress");
                setSeverity("info");
                setOpen(true);
                return;
              }
              setRecordingField(sectiondata.key);
              setIsIndRecord(true);
              indref.current=true
              recordingfieldref.current=sectiondata.key
              if(mydata.isStreaming ){
                startRecording(sectiondata.key)
              }
              window.scrollTo({ top: 0, behavior: "smooth" });
              setPopUp(false);
            }}
          >
            <MicIcon
              fontSize="small"
              style={{
                cursor: "pointer",
                width: "20px",
                height: "20px",
                color: recordingField === sectiondata ? "red" : "#000",
              }}
            />
          </div>
        </div> */}
    </div>
  </>
) : (
  <></>
)}
      {/* Copy feedback message */}
      <Snackbar
  open={copyFeedback}
  autoHideDuration={3000}
  // onClose={handleClose}
  message="Copied to clipboard!"
  // action={action}
/>
<ToastModal toastobject={toastobject} isModalOpen={toast} setModalOpen={setToast}/>
   <Backdrop
  sx={{
    color: '#fff',
    zIndex: (theme) => theme.zIndex.drawer + 1,
    backgroundColor: 'rgba(0, 0, 0, 0.7)', // reduced opacity (default is 0.5)
  }}
  open={isLoading}
>
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
    <CircularProgress color="inherit" />
    <span style={{ color: '#fff', fontSize: '14px', fontWeight: 500 }}>Loading note...</span>
    <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '11px' }}>If there's a recent edit, this may take a few seconds</span>
  </div>
</Backdrop>

   {issueModal && (
     <div className="fixed inset-0 z-[1300] flex items-center justify-center bg-black/40"
          onClick={() => { if (!issueBusy && issuePhase !== 'generating') closeIssueModal(); }}>
       <div className="bg-white rounded-xl shadow-2xl w-[min(680px,92vw)] max-h-[85vh] flex flex-col"
            onClick={(e) => e.stopPropagation()}>
         <div className="px-5 py-3 border-b border-gray-200 flex items-center justify-between">
           <div className="text-[15px] font-semibold text-[#1D2951]">
             {issuePhase === 'preview'
               ? (issueSource === 'voice' ? 'Review your voice edits' : 'Review the proposed fix')
               : 'Report an issue with this note'}
           </div>
           <button className="text-gray-400 hover:text-gray-600 text-lg"
                   onClick={() => { if (!issueBusy && issuePhase !== 'generating') closeIssueModal(); }}>✕</button>
         </div>

         {issuePhase === 'input' && (
           <div className="p-5 flex flex-col gap-3">
             <textarea
               autoFocus
               rows={4}
               value={issueText}
               onChange={(e) => setIssueText(e.target.value)}
               placeholder='What&apos;s wrong? e.g. "ICD-10 codes are missing", "lab results were not pulled in", "dose is wrong — I said 40 units"'
               className="w-full border border-gray-300 rounded-lg p-3 text-sm outline-none focus:border-[#E17954]"
             />
             <div className="text-[11px] text-[#6B7690]">
               Either way your report is logged for the engineering team. &ldquo;Fix now&rdquo; shows
               you the proposed change first — nothing is applied without your confirmation.
             </div>
             <div className="flex justify-end gap-2">
               <button
                 onClick={() => submitIssue(false)}
                 disabled={issueBusy || !issueText.trim()}
                 className="px-4 py-1.5 rounded-lg text-xs border border-gray-300 text-[#1D2951] hover:bg-gray-50 disabled:opacity-50"
               >
                 Just log it
               </button>
               <button
                 onClick={() => submitIssue(true)}
                 disabled={issueBusy || !issueText.trim()}
                 className="px-4 py-1.5 rounded-lg text-xs text-white bg-[#E17954] hover:bg-[#C0392B] disabled:opacity-50"
               >
                 {issueBusy ? 'Working…' : 'Log & fix now'}
               </button>
             </div>
           </div>
         )}

         {issuePhase === 'generating' && (
           <div className="p-8 flex flex-col items-center gap-3 text-sm text-[#1D2951]">
             <div className="animate-pulse">Generating a proposed fix…</div>
             <div className="text-[11px] text-[#6B7690]">This can take up to a minute. Nothing is changed yet.</div>
           </div>
         )}

         {issuePhase === 'preview' && (
           <>
             <div className="px-5 py-3 overflow-y-auto flex-1">
               {issueChangedSections().length === 0 ? (
                 <div className="text-sm text-[#6B7690] py-4">
                   {issueSource === 'voice'
                     ? 'The dictation produced no changes to the note.'
                     : 'The fix produced no changes to the note. Your issue stays logged for the team.'}
                 </div>
               ) : issueChangedSections().map((s) => (
                 <div key={s.key} className="mb-4">
                   <div className="text-xs font-semibold text-[#1D2951] uppercase mb-1">
                     {s.key.replace(/_/g, ' ')}
                   </div>
                   <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                     <div className="border border-gray-200 rounded-lg p-2 bg-gray-50">
                       <div className="text-[10px] text-gray-500 mb-1">BEFORE</div>
                       <div className="text-xs whitespace-pre-wrap max-h-40 overflow-y-auto">{s.before || '—'}</div>
                     </div>
                     <div className="border border-[#E17954]/40 rounded-lg p-2 bg-[#FFF7F4]">
                       <div className="text-[10px] text-[#E17954] mb-1">AFTER</div>
                       <div className="text-xs whitespace-pre-wrap max-h-40 overflow-y-auto">{s.after || '—'}</div>
                     </div>
                   </div>
                 </div>
               ))}
             </div>
             <div className="px-5 py-3 border-t border-gray-200 flex justify-end gap-2">
               <button
                 onClick={rejectIssueFix}
                 disabled={issueBusy}
                 className="px-4 py-1.5 rounded-lg text-xs border border-gray-300 text-[#1D2951] hover:bg-gray-50 disabled:opacity-50"
               >
                 {issueSource === 'voice' ? 'Discard voice edits' : 'Discard fix (keep issue logged)'}
               </button>
               {issueChangedSections().length > 0 && (
                 <button
                   onClick={applyIssueFix}
                   disabled={issueBusy}
                   className="px-4 py-1.5 rounded-lg text-xs text-white bg-[#059669] hover:bg-[#047857] disabled:opacity-50"
                 >
                   {issueBusy ? 'Applying…' : (issueSource === 'voice' ? 'Apply edits to note' : 'Apply fix to note')}
                 </button>
               )}
             </div>
           </>
         )}
       </div>
     </div>
   )}
   <ToastMessage message={alertmessage} severity={severity} open={open} handleClose={handleClose} />
    <ExitModal savemodal={isExitModal} setModalOpen={setIsexitModal} onExit={onExit}/>
 <DeleteConfirmation savemodal={deleteconfirmationModal} setModalOpen={setDeleteConfirmationModal} onExit={deleteStream}/>
    <ShareModal 
      setSeverity={setSeverity}
      data={data}
      setAlertMessage={setAlertMessage}
      setOpen={setOpen}
      selectedCard={selectedCard}  isOpen={isSharemodal} onClose={setIsShareModal}/>
      </div>
      </div>
    </>
  );
  if (embedded) return editBody;
  return createPortal(editBody, document.body);
};

export default Editscreen;
